
    import {
        Options
    } from 'vue-class-component';

  
    import BasePage from '@/common/BasePage'; // @ is an alias to /src
    

    @Options({
        components: {

        },
    })
    /**员工详情页 */
    export default class StaffDetail extends BasePage {
        /**员工数据 */
        public staff:{photoWall:string,head:string}={photoWall:"",head:""};
        backcolor="#Fff"
        mounted(): void {
            if(!localStorage.getItem("pageData")){
               return this.$router.push("/")
            }
           
            
           this.staff=JSON.parse(localStorage.getItem("pageData")!);
           this.staff.head=this.get_thumb(this.staff.photoWall, 160, 160);
            // console.log("员工信息",obj);
            
            // console.log(obj.id)
        }
        
    }
